import "./update-search-bar"
import { initialiseBookingSearchCtas } from "./booking-search-cta"

initialiseBookingSearchCtas()
